import { TraceServiceBase } from './trace-service';

// We currently do not have any tracing capabilities on the vessel, so we just ignore all events.
export class TraceServiceVessel extends TraceServiceBase {
    pageView(path: string, title?: string) {
    };

    event(category: string, action: string, label?: string, value?: number) {
    }
}
